import { render, staticRenderFns } from "./jinrong.vue?vue&type=template&id=5d34c8bc&scoped=true&"
import script from "./jinrong.vue?vue&type=script&lang=js&"
export * from "./jinrong.vue?vue&type=script&lang=js&"
import style0 from "./jinrong.vue?vue&type=style&index=0&id=5d34c8bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d34c8bc",
  null
  
)

export default component.exports